export const FAVOURITE = 'favorites';
export const SAVEFORLATER = 'saved-for-later';
